"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const definables = new Map;
exports.default = definables;
